import accessibility from "../../assets/bquiz/accessibility.webp";
import aiQuiz from "../../assets/bquiz/aiQuiz.webp";
import builder from "../../assets/bquiz/builder.webp";
import contributor from "../../assets/bquiz/contributor.webp";
import evaluate from "../../assets/bquiz/evaluate.webp";
import payment from "../../assets/bquiz/payment.webp";
import performance from "../../assets/bquiz/performance.webp";
import settings from "../../assets/bquiz/settings.webp";
import submission from "../../assets/bquiz/submission.webp";
import submits from "../../assets/bquiz/submits.webp";
import uploadFile from "../../assets/bquiz/uploadFile.webp";

import json from "./bquiz.json";
import { Project } from "../../components/project";
import { IoIosArrowForward } from "react-icons/io";

const imageMap = {
  accessibility,
  aiQuiz,
  builder,
  contributor,
  evaluate,
  payment,
  performance,
  settings,
  submission,
  submits,
  uploadFile,
};

export const Bquiz = () => {
  return (
    <div className="flex flex-col sm:items-start items-center text-primary gap-3 animate-fade-down animate-once animate-duration-1000 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both">
      <Project json={json} imageMap={imageMap} />

      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">
        Link to the project
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <a
          rel="noreferrer"
          href={"https://bquiz.co"}
          target="_blank"
          className="text-[16px] text-secondary hover:opacity-90"
        >
          BQuiz Landing Page (Built in Next Js)
        </a>
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <a
          rel="noreferrer"
          href={"https://app.bquiz.co"}
          target="_blank"
          className="text-[16px] text-secondary hover:opacity-90"
        >
          BQuiz Application (Built in React Js)
        </a>
      </div>
    </div>
  );
};
